import { MessageCircle } from "lucide-react";
import { useI18n } from "@/lib/i18n";

export default function WhatsAppFloat() {
  const { t } = useI18n();
  // Placeholder WhatsApp number — pre-launch. Users can update.
  const number = "971525996630";
  const msg = encodeURIComponent("Hi Raknati, I'd like to learn more.");
  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-5 end-5 z-40 group"
      aria-label={t("common.whatsapp")}
      data-testid="whatsapp-float"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-pulse-ring" aria-hidden="true" />
      <span className="relative inline-flex items-center justify-center h-14 w-14 rounded-full bg-[#25D366] text-white shadow-lift hover:bg-[#1EBE5B] transition-colors duration-200">
        <MessageCircle className="h-6 w-6" />
      </span>
    </a>
  );
}
